import { FC } from "react";
import { useStyles } from "src/theme/styles";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

interface LicenseInsightItemProps {
	isSingleValue?: boolean;
	singleValue?: number;
	limitValue?: number;
	calculatedValue?: number;
	poolLimitValue?: number;
	poolCalculatedValue?: number;
	label?: string;
	hasInsightsLicense?: boolean;
	isDefaultColor?: boolean;
}
const LicenseInsightItem: FC<LicenseInsightItemProps> = (props) => {
	const classes = useStyles();
	const navigate = useNavigate();
	const { t } = useTranslation();

	return (
		<div className={classes.insightItemContainer}>
			{props.hasInsightsLicense === undefined && (
				<div className={classes.insightValueText}>
					{props.isSingleValue && props.singleValue != undefined ? (
						<Typography
							display="inline"
							variant="h4"
							color="textPrimary"
							className={
								!props.isDefaultColor
									? classes.insightSingleText
									: ""
							}
						>
							{props.singleValue}
						</Typography>
					) : (
						<Typography
							variant="h4"
							display="inline"
							color="textPrimary"
						>
							<span
								className={
									props.calculatedValue > props.limitValue
										? classes.calculatedText
										: ""
								}
							>
								{props.calculatedValue}
							</span>
							<span className={classes.limitTextPadding}>/</span>
							<span className={classes.limitText}>
								{props.limitValue}
							</span>
						</Typography>
					)}
				</div>
			)}
			{props.hasInsightsLicense !== undefined && (
				<a
					className={classes.pointer}
					onClick={() => navigate("/dashboard")}
				>
					<img
						alt="WrapUpMenuIcon"
						src={`/static/menu/${
							props.hasInsightsLicense
								? "WrapUpMenuIconEnabled"
								: "WrapUpMenuIcon"
						}.svg`}
						style={{
							width: "29px",
							margin: "19px 20px 5px 20px",
						}}
					/>
				</a>
			)}
			<Typography
				display="inline"
				variant="body2"
				color="textPrimary"
				className={classes.insightLabel}
			>
				{props.label}
			</Typography>
			{props.poolCalculatedValue != undefined &&
				props.poolLimitValue != undefined && (
					<Typography
						display="inline"
						variant="body2"
						color="textPrimary"
						className={classes.insightLabel}
					>
						<span className={classes.limitTextPadding}>
							{t("License.Pool")}
						</span>
						<span
							className={
								props.poolCalculatedValue > props.poolLimitValue
									? classes.calculatedText
									: ""
							}
						>
							{props.poolCalculatedValue}
						</span>
						<span className={classes.limitTextPadding}>/</span>
						<span className={classes.limitText}>
							{props.poolLimitValue}
						</span>
					</Typography>
				)}
		</div>
	);
};

export default LicenseInsightItem;
